import ImageCropper from "./controls/ImageCropper";
import { Route, Routes } from "react-router-dom";
import "./reset.css";

function App() {
  return (
    <div className="app">
      <header className="App-header">
        <Routes>
          <Route path="/" element={<ImageCropper />} />
          <Route path="/logoImporter" element={<ImageCropper />} />
        </Routes>
      </header>
    </div>
  );
}

export default App;
